export default __webpack_public_path__ + "static/media/Audi_Retro.1f4ee497.jpg";